import React from 'react'
import {
    Box,
    Stepper,
    Step,
    StepLabel,
} from '@mui/material';
import ApprovalFormContainer from '../../containers/techmng/approval/ApprovalFormContainer'
import TechFirstStepContainer from '../../containers/rslttechmng/TechFirstStepContainer';
import TechSecondStepContainer from '../../containers/rslttechmng/TechSecondStepContainer';
import TechThirdStepContainer from '../../containers/rslttechmng/TechThirdStepContainer';
import DetailTemplate from '../common/template/DetailTemplate';
import ProjectSummary from '../techmng/support/ProjectSummary';

const steps = [
    { id: 1, value: '1', label: '지원요청', color: 'default' },
    { id: 2, value: '2', label: '지원확인', color: 'info' },
    { id: 3, value: '3', label: '작업계획', color: 'warning' },
    { id: 4, value: '4', label: '완료보고', color: 'error' },
    { id: 5, value: '5', label: '결재중', color: 'secondary' },
    { id: 6, value: '6', label: '결재완료', color: 'success' },
]

const RsltTechStepperTemplate = ({
    project,
    activeStep,
    activeTab,
    tech,
    techPlan,
    techMids,
    techMidInfo,
    techRslt,
    user,
    reloadTech,
    handleTabChange
}) => {
    return (
        <Box sx={{ my: 2 }}>
            {tech?.rsltUuid !== null && (tech.reqGrade === "4" || tech.reqGrade === '5') && (
                <ApprovalFormContainer
                    tech={tech}
                    docuCd={tech?.rsltUuid}
                    user={user}
                    type="tech"
                />
            )}
            <DetailTemplate title="프로젝트 요약">
                <ProjectSummary project={project} />
            </DetailTemplate>

            <Stepper
                sx={{
                    pt: 2,
                    pb: 1,
                    backgroundColor: '#eee',
                }}
                activeStep={activeStep}
                alternativeLabel
            >
                {steps.map((step) => {
                    const stepProps = {};
                    const labelProps = {};

                    if (activeStep === steps.length - 1) {
                        stepProps.completed = true;
                    }
                    return (
                        <Step key={step.label} {...stepProps}>
                            <StepLabel
                                {...labelProps}
                            >{step.label}</StepLabel>
                        </Step>
                    )
                })}
            </Stepper>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    my: 1,
                }}
            >
                {activeStep === 0 && (
                    <TechFirstStepContainer
                        project={project}
                        tech={tech}
                        user={user}
                        activeTap={activeTab}
                        handleTabChange={handleTabChange}
                    />
                )}
                {activeStep === 1 && (
                    <TechSecondStepContainer
                        project={project}
                        tech={tech}
                        techPlan={techPlan}
                        user={user}
                        activeTap={activeTab}
                        handleTabChange={handleTabChange}
                        reloadTech={reloadTech}
                    />

                )}
                {activeStep >= 2 && (
                    <TechThirdStepContainer
                        project={project}
                        tech={tech}
                        techMids={techMids}
                        techMidInfo={techMidInfo}
                        techPlan={techPlan}
                        techRslt={techRslt}
                        user={user}
                        activeTap={activeTab}
                        handleTabChange={handleTabChange}
                        reloadTech={reloadTech}
                    />
                )}
            </Box>
        </Box>
    )
}

export default RsltTechStepperTemplate